import { NumberFormatBase, usePatternFormat } from 'react-number-format';
import type { ChangeMeta, OnValueChange, PatternFormatProps } from 'react-number-format';

import type { Country } from './model';

interface Props {
  country: Country;
  value: string;
  onValueChange: OnValueChange;
  removeFormatting: (value: string, changeMeta?: ChangeMeta) => string;
  disabled?: boolean;
  className?: string;
}

export const PhonePatternInput = ({
  country,
  value,
  onValueChange,
  removeFormatting,
  disabled = false,
  className,
}: Props) => {
  const patternFormatProps = usePatternFormat({
    value,
    onValueChange,
    format: country.format,
    mask: country.mask,
    allowEmptyFormatting: true,
    disabled,
    type: 'tel',
  } satisfies PatternFormatProps);

  return (
    <NumberFormatBase
      {...patternFormatProps}
      removeFormatting={removeFormatting}
      className={className}
      disabled={disabled}
      type="tel"
    />
  );
};
